import './SearchInput.css';
import {forwardRef, useCallback, useState} from 'react';
import {classNames} from '../../utilities/classNames';
import {Icon} from '../Icon';

export const SearchInput = forwardRef<HTMLInputElement, UI.SearchInput.Props>(function SearchInput(
  {className, tone, onClear, value, defaultValue, onChange, ...attributes},
  ref,
) {
  const [internalValue, setInternalValue] = useState(defaultValue ?? '');
  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : internalValue;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!isControlled) {
        setInternalValue(e.target.value);
      }
      onChange?.(e);
    },
    [isControlled, onChange],
  );

  const handleClear = useCallback(() => {
    if (!isControlled) {
      setInternalValue('');
    }
    onClear?.();
  }, [isControlled, onClear]);

  const classes = classNames('SearchInput', className, {
    'tone-default': tone == null || tone === 'default',
    'tone-danger': tone === 'danger',
    'tone-info': tone === 'info',
    'tone-neutral': tone === 'neutral',
    'tone-success': tone === 'success',
    'tone-warning': tone === 'warning',
  });

  return (
    <div className={classes}>
      <div className="search-icon" aria-hidden="true">
        <Icon name="search" size="sm" />
      </div>
      <input
        {...attributes}
        ref={ref}
        type="search"
        value={currentValue}
        onChange={handleChange}
        className="search-field"
      />
      {currentValue && (
        <button
          type="button"
          className="clear-button"
          onClick={handleClear}
          aria-label="Limpar busca"
        >
          <Icon name="close" size="sm" />
        </button>
      )}
    </div>
  );
});
